import type { SerializedError } from '@reduxjs/toolkit';

import { genericErrorMessage } from './serverErrorFormatter';

export function formatRTKQuerySerializedError(error: SerializedError) {
  return error.message || genericErrorMessage;
}
